import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input']

  connect() {
    this.element.querySelector('.inbox-filter.active')?.scrollIntoView({ block: 'nearest', inline: 'nearest' })
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  search() {
    // Turbo page snapshots copy attributes, not typed text, and syncWithNewPage reads those snapshots.
    this.inputTarget.setAttribute('value', this.inputTarget.value)
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), 250)
  }

  syncWithNewPage(event) {
    const newInput = event.detail.newBody.querySelector(`#${this.inputTarget.id}`)

    if (newInput) this.inputTarget.value = newInput.value
  }
}
